import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFirestore } from "../../firebase/FirestoreContext";
import { getDoc, doc, addDoc, updateDoc, deleteDoc, collection } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EnvContext } from "../../../context/EnvContext";
import config from "../../../config";

const EditFAQ = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const environment = useContext(EnvContext);
  const db = useFirestore();

  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  const [faqData, setFaqData] = useState({
    question: "",
    answer: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      // Fetch existing FAQ when ID exists (editing mode)
      const fetchFAQ = async () => {
        try {
          const docRef = doc(db, `${collectionPath}Help/FAQ/DataBase`, id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setFaqData(docSnap.data());
          }
        } catch (error) {
          console.error("Error fetching FAQ data:", error);
        }
      };

      fetchFAQ();
    } else {
      // Reset form when creating new FAQ
      setFaqData({
        question: "",
        answer: "",
      });
    }
  }, [id, db, collectionPath]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (id) {
        // Update existing FAQ
        const faqRef = doc(db, `${collectionPath}Help/FAQ/DataBase`, id);
        await updateDoc(faqRef, faqData);
        toast.success("FAQ updated successfully!");
      } else {
        // Create new FAQ
        await addDoc(collection(db, `${collectionPath}Help/FAQ/DataBase`), faqData);
        toast.success("FAQ created successfully!");
      }

      navigate("/main/faq"); // Navigate back to FAQ list
    } catch (error) {
      toast.error("Error saving FAQ!");
      console.error("Error saving FAQ:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const confirmed = window.confirm("Are you sure you want to delete this FAQ?");
    if (!confirmed) return;

    try {
      const faqRef = doc(db, `${collectionPath}Help/FAQ/DataBase`, id);
      await deleteDoc(faqRef);
      toast.success("FAQ deleted successfully!");

      navigate("/main/faq"); // Navigate back to FAQ list
    } catch (error) {
      toast.error("Error deleting FAQ!");
      console.error("Error deleting FAQ:", error);
    }
  };

  return (
    <div>
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar />
      <h2 style={styles.title}>{id ? "Edit FAQ" : "New FAQ"}</h2>

      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formElement}>
          <label style={styles.formLabel}>Question:</label>
          <input type="text" value={faqData.question} onChange={(e) => setFaqData({ ...faqData, question: e.target.value })} style={styles.formInput} />
        </div>

        <div style={styles.formElement}>
          <label style={styles.formLabel}>Answer:</label>
          <textarea value={faqData.answer} onChange={(e) => setFaqData({ ...faqData, answer: e.target.value })} style={styles.formTextarea} />
        </div>

        <div style={styles.buttonGroup}>
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>

          {id && (
            <button type="button" style={styles.deleteButton} onClick={handleDelete}>
              Delete
            </button>
          )}

          <button type="button" style={styles.cancelButton} onClick={() => navigate("/main/faq")}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  title: {
    fontWeight: "200",
    paddingBottom: "10px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    backgroundColor: "#f9f9f9",
  },
  formElement: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  formLabel: {
    fontWeight: "bold",
    fontSize: "14px",
    color: "#4a4141",
  },
  formInput: {
    padding: "10px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  formTextarea: {
    padding: "10px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    height: "100px",
    resize: "vertical",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    marginTop: "10px",
  },
  button: {
    backgroundColor: "#478169",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
  deleteButton: {
    backgroundColor: "red",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
  cancelButton: {
    backgroundColor: "#ccc",
    color: "black",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default EditFAQ;
